<template>
    <div class="form-body">

        <transition name="fade" mode="out-in">
            <nuxt/>
        </transition>

    </div>
</template>

<script>
    export default {
        mounted() {
            //$('body').addClass('rtl')
        }
    }
</script>

<style scoped>

</style>
